import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { ProductCard } from "../components/ProductCard";

export default function WishlistPage() {
  const { wishlist } = useShop();

  const asProduct = (i) => ({
    id: i.id, name: i.name, price: i.price, original_price: i.original_price,
    images: [i.image], fabric: i.fabric || "Handloom", is_new: false, rating: 4.7, reviews_count: 0,
  });

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16" data-testid="wishlist-page">
      <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">Saved for later</p>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-2">Your Wishlist</h1>

      {wishlist.length === 0 ? (
        <div className="text-center py-24" data-testid="wishlist-empty">
          <Heart className="w-10 h-10 text-gold mx-auto" strokeWidth={1} />
          <p className="text-charcoal/60 mt-4">No sarees saved yet. Tap the heart on any saree to keep it here.</p>
          <Link to="/shop" data-testid="wishlist-shop-link" className="inline-block mt-8 bg-maroon text-ivory text-xs tracking-[0.18em] uppercase px-8 py-3.5 hover:bg-maroon-dark">
            Browse Sarees
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8 mt-10" data-testid="wishlist-grid">
          {wishlist.map((i) => (
            <ProductCard key={i.id} product={asProduct(i)} />
          ))}
        </div>
      )}
    </main>
  );
}
